import CompanyEditor from './editor'

export default CompanyEditor
